import { cls } from "cls";
import React from "react";
interface Props {
  image: string;
  description: string;
  productLink: string;
  itemNumber: string;
}
const ImageAndDescription = ({
  image,
  description,
  productLink,
  itemNumber
}: Props) => {
  return <div className={cls("md:w-3/4", "flex", "py-6", "md:pt-8")} data-sentry-component="ImageAndDescription" data-sentry-source-file="ImageAndDescription.tsx">
      <img src={image} alt="" className={cls("border", "border-solid", "border-gray-300", "rounded-sm", "mr-2")} style={{
      width: "84px",
      height: "84px"
    }} data-testid="modalProductImage" />
      <div className={cls("my-auto")}>
        <p className={cls("text-green-700", "text-base", "leading-5", "mb-0", "font-semibold", "w-full")}>
          <a href={productLink} data-testid="product-link">
            {description}
          </a>
        </p>
        <p className={cls("text-gray-800", "text-xs", "font-normal", "m-0", "pt-1")}>
          #{itemNumber.toUpperCase()}
        </p>
      </div>
    </div>;
};
export default ImageAndDescription;